var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.25,
    y1: 17,
    x2: 22.72,
    y2: 16.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a0ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.29,
    y1: 20.07,
    x2: 22.76,
    y2: 19.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.3,
    y1: 20.14,
    x2: 22.76,
    y2: 19.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.3,
    y1: 20.21,
    x2: 22.77,
    y2: 19.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.3,
    y1: 20.28,
    x2: 22.77,
    y2: 19.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.18,
    y1: 12.18,
    x2: 22.64,
    y2: 11.84,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.56,16.37c0-.59-.48-1.08-1.08-1.08H3.08c-.59,0-1.08,.48-1.08,1.08v1.14c0,.59,.48,1.08,1.08,1.08h2.41c.59,0,1.08-.48,1.08-1.08v-1.14Zm-1.04,1.14s-.02,.04-.04,.04l-2.45-.04,.04-1.19,2.45,.04v1.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.88,19.51H2.52c-.29,0-.52,.23-.52,.52s.23,.52,.52,.52h2.37c.29,0,.52-.23,.52-.52s-.23-.52-.52-.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.36,19.51h-2.37c-.29,0-.52,.23-.52,.52s.23,.52,.52,.52h2.37c.29,0,.52-.23,.52-.52s-.23-.52-.52-.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.84,19.51h-2.37c-.29,0-.52,.23-.52,.52s.23,.52,.52,.52h2.37c.29,0,.52-.23,.52-.52s-.23-.52-.52-.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.33,19.51h-2.37c-.29,0-.52,.23-.52,.52s.23,.52,.52,.52h2.37c.29,0,.52-.23,.52-.52s-.23-.52-.52-.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.68,4.05c-.25-.32-.61-.52-1.01-.56L4.99,1.37c-.41-.05-.8,.06-1.12,.31-.32,.25-.52,.61-.57,1.01l-.28,2.33s0,0,0,0,0,0,0,0l-.47,3.94H1.52C.68,8.97,0,9.65,0,10.49v10.64c0,.84,.68,1.52,1.52,1.52H19.32c.84,0,1.52-.68,1.52-1.52v-4.09l.21,.03c.06,0,.11,0,.17,0,.76,0,1.42-.57,1.51-1.34l.98-8.21s0-.01,0-.02c0,0,0-.01,0-.02l.28-2.31c.05-.4-.06-.8-.31-1.12Zm-3.87,17.08c0,.26-.21,.48-.48,.48H1.52c-.26,0-.48-.21-.48-.48V10.49c0-.26,.21-.48,.48-.48H19.32c.26,0,.48,.21,.48,.48v10.64Zm1.89-5.52c-.03,.26-.27,.45-.52,.42l-.33-.04v-5.5c0-.84-.68-1.52-1.52-1.52H3.6l.39-3.31,18.63,2.23-.92,7.72Zm1.05-8.75L4.11,4.63l.22-1.81c.02-.13,.08-.24,.18-.32,.1-.08,.23-.11,.35-.1l17.68,2.11c.13,.01,.24,.08,.32,.18s.11,.22,.1,.35l-.22,1.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.94d40740e7e709c1395d55e063447169.svg";
export { ForwardRef as ReactComponent };